export default __webpack_public_path__ + "static/media/rupee-sign.334bf946.svg";